import { SxProps, Theme } from '@mui/material/styles';

// Using theme.spacing for consistent spacing
export const rootBoxSx: SxProps<Theme> = (theme: Theme) => ({
  marginLeft: theme.spacing(4),
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(4),
});

export const headerBoxSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(3),
});

export const titleSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
  fontWeight: theme.typography.h1.fontWeight,
});

export const paperSx: SxProps<Theme> = (theme: Theme) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  marginBottom: theme.spacing(2),
});

export const sectionBoxSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(1),
});

export const sectionTitleSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
});

export const subtextSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
});

export const formLabelSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
  fontSize: theme.typography.caption.fontSize,
});

export const previewBoxSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'inline-flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
  minWidth: 216, // 200 + 16 (1rem more)
});

export const previewMetricNameSx: SxProps<Theme> = (theme: Theme) => ({
  fontSize: theme.typography.body2.fontSize,
});

export const previewValueSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: '1.25rem', // 20px - custom size for display value
  color: theme.palette.primary.dark,
});

// Skeleton styles
export const skeletonHeaderTitleSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
});

export const skeletonSectionTitleSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing(1),
});

export const skeletonSectionSubtextSx: SxProps<Theme> = (theme: Theme) => ({
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing(1),
});

export const skeletonGridContainerSx: SxProps<Theme> = (theme: Theme) => ({
  marginLeft: theme.spacing(0.5),
});

export const skeletonGridContainerWithMarginSx: SxProps<Theme> = (theme: Theme) => ({
  marginLeft: theme.spacing(0.5),
  marginBottom: theme.spacing(2),
});

// MetricsInUse link button styles
export const metricsInUseButtonSx: SxProps<Theme> = {
  cursor: 'pointer',
  textDecoration: 'underline',
  textTransform: 'none',
  p: 0,
  minWidth: 'auto',
  '&:hover': { textDecoration: 'underline' },
};

export const datasetSwitchDialogContentSx: SxProps<Theme> = (theme: Theme) => ({
  paddingTop: theme.spacing(2),
});

// Dialog styles for MetricsInUseDialog
export const dialogContentSx: SxProps<Theme> = {
  pt: 2,
  pb: 4,
};

export const dialogDescriptionBoxSx: SxProps<Theme> = {
  mb: 3,
};

export const dialogMetricNameSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: 'bold',
  color: theme.palette.text.primary,
});

export const dialogActionsSx: SxProps<Theme> = {
  p: 2,
  pt: 0,
};

export const dialogOkButtonSx: SxProps<Theme> = {
  minWidth: '80px',
};

export const metricsInUseLinkSx = {
  textTransform: 'none',
  textDecoration: 'underline',
  padding: 0,
  minWidth: 'auto',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
};

export const breadcrumbsSx: SxProps<Theme> = {
  marginBottom: 2,
  '& .MuiTypography-root': { fontSize: '12px' },
};

export const breadcrumbLinkSx: SxProps<Theme> = (theme: Theme) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
});

export const breadcrumbTextSx: SxProps<Theme> = (theme: Theme) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
});
